import React from "react";

import FaceMeshAsyncV2Page from "./FaceMeshAsyncV2Page";
import { buildHairstyleUserPhotoContinueUrl } from "./hairstyleUserPhotoContinue";

const HAIRSTYLE_PROGRESS_STEPS = [
  { threshold: 10, label: "Analyzing face shape for haircut fit" },
  { threshold: 35, label: "Evaluating volume and balance points" },
  { threshold: 60, label: "Analyzing framing lines around the face" },
  { threshold: 85, label: "Matching styles to your natural silhouette" },
  { threshold: 100, label: "Selecting your best hairstyle direction" },
];

const FaceMeshHairstyleV2Page = () => (
  <FaceMeshAsyncV2Page
    analyticsPrefix="facemesh_hairstyle_v2"
    continueUrl="/hairstyle-3month-29-woman"
    buildContinueUrlOverride={buildHairstyleUserPhotoContinueUrl}
    missingImageHelpPath="/facemesh-hairstyle-v2"
    pagePath="/facemesh-hairstyle-v2"
    progressSteps={HAIRSTYLE_PROGRESS_STEPS}
  />
);

export default FaceMeshHairstyleV2Page;
